module.exports = __webpack_public_path__ + "img/climate_actions_energyscouts.079838f.svg";